import { useEffect, useRef } from "react";

export const usePrevious = <T = any>(value: T): T | undefined => {
    const ref = useRef<T>();

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
};

export const usePreviousUpdated = <T = any>(value: T): T | undefined => {
    const previousRef = useRef<T>();
    const ref = useRef<T>();

    useEffect(() => {
        if (previousRef.current !== value) {
            ref.current = previousRef.current;
            previousRef.current = value;
        }
    }, [value]);

    return ref.current;
};
